module.exports = __webpack_public_path__ + "static/womens-group-4ea5b0cd5c450304568588ad94deb4aa.jpg";